var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28464",
    "data-name": "Group 28464",
    transform: "translate(-54 -621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Language_2712648",
    transform: "translate(57 623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45439",
    "data-name": "Path 45439",
    d: "M14,4A10,10,0,1,0,24,14,10,10,0,0,0,14,4Zm7.789,6.429h-3.4a12.975,12.975,0,0,0-2.536-4.8A8.6,8.6,0,0,1,21.789,10.429ZM13.961,22.236h0a11.586,11.586,0,0,1-2.854-4.664h5.786a11.586,11.586,0,0,1-2.857,4.664A.064.064,0,0,1,13.961,22.236Zm-3.214-6.093a11.786,11.786,0,0,1,0-4.286h6.507a11.786,11.786,0,0,1,0,4.286ZM5.429,14A8.489,8.489,0,0,1,5.7,11.857H9.3a13.214,13.214,0,0,0,0,4.286H5.7A8.489,8.489,0,0,1,5.429,14ZM14,5.75a.054.054,0,0,1,.039,0,11.586,11.586,0,0,1,2.854,4.679H11.107a11.586,11.586,0,0,1,2.857-4.664A.054.054,0,0,1,14,5.75Zm4.7,6.107h3.6a8.593,8.593,0,0,1,0,4.286H18.7a13.214,13.214,0,0,0,0-4.286ZM12.15,5.632a13.029,13.029,0,0,0-2.536,4.8h-3.4a8.6,8.6,0,0,1,5.939-4.8ZM6.211,17.571h3.4a12.975,12.975,0,0,0,2.536,4.8,8.6,8.6,0,0,1-5.939-4.8Zm9.643,4.8a13.029,13.029,0,0,0,2.532-4.8h3.4a8.6,8.6,0,0,1-5.939,4.8Z",
    transform: "translate(-4 -4)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.25
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.325e419c.svg";
export { ForwardRef as ReactComponent };